import { useTranslation } from 'react-i18next';

import { PauseAction } from '@/shared/types/action';

const Pause = ({ action }: { action: PauseAction }) => {
  const { t } = useTranslation();
  return (
    <span className="text-sm leading-5 font-normal text-muted-foreground">
      {`${action.duration ?? 0} ${t('dialog.actions.seconds_abbreviation')} `}
    </span>
  );
};

export default Pause;
